
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "filter"
})
export class FilterPipe implements PipeTransform {
  transform(collection: Array<any>, query, fields: Array<any>): Array<any> {
    if (!query || !collection) {
      return collection;
    }

    return collection.filter(item => fields.find(key => {
        let field = item[key];
        field = field ? field.toString() : "";

        return field.toLowerCase().includes(query.toLowerCase());
    }));
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/filter.pipe.ts